import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FormValidation.css';

// Countries array with ISO 3166 Alpha-2 codes
const countries = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AQ', name: 'Antarctica' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AW', name: 'Aruba' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BM', name: 'Bermuda' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BV', name: 'Bouvet Island' },
  { code: 'BR', name: 'Brazil' },
  { code: 'IO', name: 'British Indian Ocean Territory' },
  { code: 'BN', name: 'Brunei Darussalam' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'CV', name: 'Cabo Verde' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'KY', name: 'Cayman Islands' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CX', name: 'Christmas Island' },
  { code: 'CC', name: 'Cocos (Keeling) Islands' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Congo' },
  { code: 'CD', name: 'Congo, Democratic Republic of the' },
  { code: 'CK', name: 'Cook Islands' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CI', name: 'Côte d\'Ivoire' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czechia' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FK', name: 'Falkland Islands (Malvinas)' },
  { code: 'FO', name: 'Faroe Islands' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GF', name: 'French Guiana' },
  { code: 'PF', name: 'French Polynesia' },
  { code: 'TF', name: 'French Southern Territories' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GR', name: 'Greece' },
  { code: 'GL', name: 'Greenland' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'GU', name: 'Guam' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HM', name: 'Heard Island and McDonald Islands' },
  { code: 'VA', name: 'Holy See (Vatican City State)' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran, Islamic Republic of' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IM', name: 'Isle of Man' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
  { code: 'JE', name: 'Jersey' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'Korea, Democratic People\'s Republic of' },
  { code: 'KR', name: 'Korea, Republic of' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: 'Lao People\'s Democratic Republic' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MO', name: 'Macao' },
  { code: 'MK', name: 'Macedonia, the former Yugoslav Republic of' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MQ', name: 'Martinique' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'MX', name: 'Mexico' },
  { code: 'FM', name: 'Micronesia, Federated States of' },
  { code: 'MD', name: 'Moldova, Republic of' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MS', name: 'Montserrat' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NC', name: 'New Caledonia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NU', name: 'Niue' },
  { code: 'NF', name: 'Norfolk Island' },
  { code: 'MP', name: 'Northern Mariana Islands' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PS', name: 'Palestine, State of' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PN', name: 'Pitcairn' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RE', name: 'Réunion' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russian Federation' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'BL', name: 'Saint Barthélemy' },
  { code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha' },
  { code: 'KN', name: 'Saint Kitts and Nevis' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'MF', name: 'Saint Martin (French part)' },
  { code: 'PM', name: 'Saint Pierre and Miquelon' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Sao Tome and Principe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SX', name: 'Sint Maarten (Dutch part)' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syrian Arab Republic' },
  { code: 'TW', name: 'Taiwan, Province of China' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'Tanzania, United Republic of' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TK', name: 'Tokelau' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TC', name: 'Turks and Caicos Islands' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'UM', name: 'United States Minor Outlying Islands' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Viet Nam' },
  { code: 'VG', name: 'Virgin Islands, British' },
  { code: 'VI', name: 'Virgin Islands, U.S.' },
  { code: 'WF', name: 'Wallis and Futuna' },
  { code: 'EH', name: 'Western Sahara' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' }
];

// Move Step components outside to prevent recreation
const Step1BMOName = ({
  step1Data,
  handleStep1Change,
  validateStep1,
  checkForDuplicates,
  submitStep1Data,
  loadingStates,
  nextStep,
  validationErrors,
  setValidationErrors,
  showStep1ConfirmModal,
  setShowStep1ConfirmModal,
  setStep1Locked
}) => {

  const handleNext = async () => {
    const isValid = validateStep1();
    if (isValid) {
      const noDuplicates = await checkForDuplicates();
      if (noDuplicates) {
        const success = await submitStep1Data();
        if (success) {
          nextStep();
        }
      }
    }
  };

  return (
    <div>
      <h3>Bursary Management Organisation Information</h3>

      {/* Placeholder for BMO name fields */}
      <div className="form-floating mb-3">
        <input
          className={`form-control ${validationErrors.bmo_name ? 'is-invalid' : ''}`}
          type="text"
          id="bmoNameInput"
          value={step1Data.bmo_name || ''}
          onChange={(e) => handleStep1Change('bmo_name', e.target.value)}
          placeholder="BMO Name"
        />
        <label htmlFor="bmoNameInput">BMO Name</label>
        {validationErrors.bmo_name && (
          <div className="invalid-feedback">{validationErrors.bmo_name}</div>
        )}
      </div>

      {/* Domain field */}
      <div className="form-floating mb-3">
        <input
          className={`form-control ${validationErrors.domain ? 'is-invalid' : ''}`}
          type="text"
          id="domainInput"
          value={step1Data.domain || ''}
          onChange={(e) => handleStep1Change('domain', e.target.value)}
          placeholder="Full domain e.g. google.com"
        />
        <label htmlFor="domainInput">Full domain e.g. google.com</label>
        {validationErrors.domain && (
          <div className="invalid-feedback">{validationErrors.domain}</div>
        )}
      </div>

      {/* Additional BMO information fields will be added here */}

      <button
        className="btn btn-primary mt-4"
        onClick={handleNext}
        disabled={loadingStates.step1 || loadingStates.step1DuplicateCheck}
      >
        {loadingStates.step1DuplicateCheck 
          ? 'Checking for duplicates...' 
          : loadingStates.step1 
            ? 'Submitting...' 
            : 'Submit & Continue'
        }
      </button>
    </div>
  );
};

const Step2BMOAddress = ({
  step2Data,
  handleStep2Change,
  validateStep2,
  submitStep2Data,
  loadingStates,
  nextStep,
  previousStep,
  validationErrors,
  setValidationErrors,
  showStep2ConfirmModal,
  setShowStep2ConfirmModal,
  setStep2Locked
}) => {

  const handleNext = async () => {
    const isValid = validateStep2();
    if (isValid) {
      const success = await submitStep2Data();
      if (success) {
        nextStep();
      }
    }
  };

  return (
    <div>
      <h3>BMO Address Information</h3>

      {/* Country - Full width - Dropdown with all countries */}
      <div className="form-floating mb-3">
        <select
          className={`form-select ${validationErrors.country ? 'is-invalid' : ''}`}
          id="countryInput"
          value={step2Data.country || ''}
          onChange={(e) => handleStep2Change('country', e.target.value)}
        >
          <option value="">Select Country</option>
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>
        <label htmlFor="countryInput">Country</label>
        {validationErrors.country && (
          <div className="invalid-feedback">{validationErrors.country}</div>
        )}
      </div>

      {/* Province/State - Full width - South African Provinces */}
      <div className="form-floating mb-3">
        <select
          className={`form-select ${validationErrors.province ? 'is-invalid' : ''}`}
          id="provinceInput"
          value={step2Data.province || ''}
          onChange={(e) => handleStep2Change('province', e.target.value)}
        >
          <option value="">Select Province</option>
          <option value="Eastern Cape">Eastern Cape</option>
          <option value="Free State">Free State</option>
          <option value="Gauteng">Gauteng</option>
          <option value="KwaZulu-Natal">KwaZulu-Natal</option>
          <option value="Limpopo">Limpopo</option>
          <option value="Mpumalanga">Mpumalanga</option>
          <option value="Northern Cape">Northern Cape</option>
          <option value="North West">North West</option>
          <option value="Western Cape">Western Cape</option>
        </select>
        <label htmlFor="provinceInput">Province</label>
        {validationErrors.province && (
          <div className="invalid-feedback">{validationErrors.province}</div>
        )}
      </div>

      {/* Address Line 1 and Address Line 2 - Horizontally aligned */}
      <div className="row mb-3">
        <div className="col-md-6">
          <div className="form-floating">
            <input
              className={`form-control ${validationErrors.address_line_1 ? 'is-invalid' : ''}`}
              type="text"
              id="addressLine1Input"
              placeholder="Address Line 1"
              value={step2Data.address_line_1 || ''}
              onChange={(e) => handleStep2Change('address_line_1', e.target.value)}
            />
            <label htmlFor="addressLine1Input">Address Line 1</label>
            {validationErrors.address_line_1 && (
              <div className="invalid-feedback">{validationErrors.address_line_1}</div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating">
            <input
              className={`form-control ${validationErrors.address_line_2 ? 'is-invalid' : ''}`}
              type="text"
              id="addressLine2Input"
              placeholder="Address Line 2 (Optional)"
              value={step2Data.address_line_2 || ''}
              onChange={(e) => handleStep2Change('address_line_2', e.target.value)}
            />
            <label htmlFor="addressLine2Input">Address Line 2 (Optional)</label>
            {validationErrors.address_line_2 && (
              <div className="invalid-feedback">{validationErrors.address_line_2}</div>
            )}
          </div>
        </div>
      </div>

      {/* Suburb and City - Horizontally aligned */}
      <div className="row mb-3">
        <div className="col-md-6">
          <div className="form-floating">
            <input
              className={`form-control ${validationErrors.suburb ? 'is-invalid' : ''}`}
              type="text"
              id="suburbInput"
              placeholder="Suburb"
              value={step2Data.suburb || ''}
              onChange={(e) => handleStep2Change('suburb', e.target.value)}
            />
            <label htmlFor="suburbInput">Suburb</label>
            {validationErrors.suburb && (
              <div className="invalid-feedback">{validationErrors.suburb}</div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating">
            <input
              className={`form-control ${validationErrors.city ? 'is-invalid' : ''}`}
              type="text"
              id="cityInput"
              placeholder="City"
              value={step2Data.city || ''}
              onChange={(e) => handleStep2Change('city', e.target.value)}
            />
            <label htmlFor="cityInput">City</label>
            {validationErrors.city && (
              <div className="invalid-feedback">{validationErrors.city}</div>
            )}
          </div>
        </div>
      </div>

      {/* Postcode - Full width */}
      <div className="form-floating mb-3">
        <input
          className={`form-control ${validationErrors.postcode ? 'is-invalid' : ''}`}
          type="text"
          id="postcodeInput"
          placeholder="Postal code/Zip"
          value={step2Data.postcode || ''}
          onChange={(e) => handleStep2Change('postcode', e.target.value)}
        />
        <label htmlFor="postcodeInput">Postal code/Zip</label>
        {validationErrors.postcode && (
          <div className="invalid-feedback">{validationErrors.postcode}</div>
        )}
      </div>

      <div className="d-flex justify-content-between mt-4">
        <button
          className="btn btn-secondary"
          onClick={previousStep}
        >
          Previous
        </button>
        <button
          className="btn btn-primary"
          onClick={handleNext}
          disabled={loadingStates.step2}
        >
          {loadingStates.step2 ? 'Submitting...' : 'Submit & Continue'}
        </button>
      </div>
    </div>
  );
};

const Step3BMORepresentatives = ({
  step1Data,
  step3Data,
  handleStep3Change,
  validateStep3,
  submitStep3Data,
  loadingStates,
  previousStep,
  validationErrors,
  setValidationErrors
}) => {

  const handleNext = async () => {
    const isValid = validateStep3();
    if (isValid) {
      await submitStep3Data();
    }
  };

  const getEmailPlaceholder = () => {
    return step1Data.domain ? `example@${step1Data.domain}` : 'Email Address';
  };

  return (
    <div>
      <h3>BMO Representatives</h3>

      {/* Domain requirement info */}
      {step1Data.domain && (
        <div className="alert alert-info mb-4" role="alert">
          <i className="fas fa-info-circle me-2"></i>
          <strong>Email Domain Requirement:</strong> All representative email addresses must use the domain <strong>@{step1Data.domain}</strong>
        </div>
      )}

      {/* General error display */}
      {validationErrors.general && (
        <div className="alert alert-danger mb-4" role="alert">
          {validationErrors.general}
        </div>
      )}

      {/* Primary Representative Section */}
      <div className="mb-4">
        <h5 className="text-primary mb-3">Primary Representative</h5>
        
        <div className="row">
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.primary_first_name ? 'is-invalid' : ''}`}
                type="text"
                id="primaryFirstNameInput"
                value={step3Data.primary_first_name || ''}
                onChange={(e) => handleStep3Change('primary_first_name', e.target.value)}
                placeholder="First Name"
              />
              <label htmlFor="primaryFirstNameInput">First Name *</label>
              {validationErrors.primary_first_name && (
                <div className="invalid-feedback">{validationErrors.primary_first_name}</div>
              )}
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.primary_last_name ? 'is-invalid' : ''}`}
                type="text"
                id="primaryLastNameInput"
                value={step3Data.primary_last_name || ''}
                onChange={(e) => handleStep3Change('primary_last_name', e.target.value)}
                placeholder="Last Name"
              />
              <label htmlFor="primaryLastNameInput">Last Name *</label>
              {validationErrors.primary_last_name && (
                <div className="invalid-feedback">{validationErrors.primary_last_name}</div>
              )}
            </div>
          </div>
        </div>

        <div className="form-floating mb-3">
          <input
            className="form-control"
            type="text"
            id="primaryTitleInput"
            value={step3Data.primary_title || ''}
            onChange={(e) => handleStep3Change('primary_title', e.target.value)}
            placeholder="Title"
          />
          <label htmlFor="primaryTitleInput">Title (Optional)</label>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.primary_phone_number ? 'is-invalid' : ''}`}
                type="tel"
                id="primaryPhoneInput"
                value={step3Data.primary_phone_number || ''}
                onChange={(e) => handleStep3Change('primary_phone_number', e.target.value)}
                placeholder="Phone Number"
              />
              <label htmlFor="primaryPhoneInput">Phone Number *</label>
              {validationErrors.primary_phone_number && (
                <div className="invalid-feedback">{validationErrors.primary_phone_number}</div>
              )}
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.primary_email_address ? 'is-invalid' : ''}`}
                type="email"
                id="primaryEmailInput"
                value={step3Data.primary_email_address || ''}
                onChange={(e) => handleStep3Change('primary_email_address', e.target.value)}
                placeholder={getEmailPlaceholder()}
              />
              <label htmlFor="primaryEmailInput">
                Email Address * {step1Data.domain && <small className="text-muted">(@{step1Data.domain})</small>}
              </label>
              {validationErrors.primary_email_address && (
                <div className="invalid-feedback">{validationErrors.primary_email_address}</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Secondary Representative Section */}
      <div className="mb-4">
        <h5 className="text-secondary mb-3">Secondary Representative</h5>
        
        <div className="row">
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.secondary_first_name ? 'is-invalid' : ''}`}
                type="text"
                id="secondaryFirstNameInput"
                value={step3Data.secondary_first_name || ''}
                onChange={(e) => handleStep3Change('secondary_first_name', e.target.value)}
                placeholder="First Name"
              />
              <label htmlFor="secondaryFirstNameInput">First Name *</label>
              {validationErrors.secondary_first_name && (
                <div className="invalid-feedback">{validationErrors.secondary_first_name}</div>
              )}
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.secondary_last_name ? 'is-invalid' : ''}`}
                type="text"
                id="secondaryLastNameInput"
                value={step3Data.secondary_last_name || ''}
                onChange={(e) => handleStep3Change('secondary_last_name', e.target.value)}
                placeholder="Last Name"
              />
              <label htmlFor="secondaryLastNameInput">Last Name *</label>
              {validationErrors.secondary_last_name && (
                <div className="invalid-feedback">{validationErrors.secondary_last_name}</div>
              )}
            </div>
          </div>
        </div>

        <div className="form-floating mb-3">
          <input
            className="form-control"
            type="text"
            id="secondaryTitleInput"
            value={step3Data.secondary_title || ''}
            onChange={(e) => handleStep3Change('secondary_title', e.target.value)}
            placeholder="Title"
          />
          <label htmlFor="secondaryTitleInput">Title (Optional)</label>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.secondary_phone_number ? 'is-invalid' : ''}`}
                type="tel"
                id="secondaryPhoneInput"
                value={step3Data.secondary_phone_number || ''}
                onChange={(e) => handleStep3Change('secondary_phone_number', e.target.value)}
                placeholder="Phone Number"
              />
              <label htmlFor="secondaryPhoneInput">Phone Number *</label>
              {validationErrors.secondary_phone_number && (
                <div className="invalid-feedback">{validationErrors.secondary_phone_number}</div>
              )}
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="form-floating mb-3">
              <input
                className={`form-control ${validationErrors.secondary_email_address ? 'is-invalid' : ''}`}
                type="email"
                id="secondaryEmailInput"
                value={step3Data.secondary_email_address || ''}
                onChange={(e) => handleStep3Change('secondary_email_address', e.target.value)}
                placeholder={getEmailPlaceholder()}
              />
              <label htmlFor="secondaryEmailInput">
                Email Address * {step1Data.domain && <small className="text-muted">(@{step1Data.domain})</small>}
              </label>
              {validationErrors.secondary_email_address && (
                <div className="invalid-feedback">{validationErrors.secondary_email_address}</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* User Permissions and Administration Section */}
      <div className="mb-4">
        <h5 className="text-info mb-3">User Permissions and Administration</h5>
        
        {/* Self Administration Option */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="selfadministerCheck"
            checked={step3Data.selfadminister || false}
            onChange={(e) => handleStep3Change('selfadminister', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="selfadministerCheck">
            <strong>Enable Self-Administration</strong>
            <div className="text-muted small">
              Check this box if the BMO will manage their own user permissions. If unchecked, the main system will handle user permission management.
            </div>
          </label>
        </div>

        {/* User Permission Administrator Fields - Only show if selfadminister is true */}
        {step3Data.selfadminister && (
          <div className="border p-3 rounded bg-light">
            <h6 className="text-muted mb-3">User Permission Administrator Details</h6>
            
            <div className="row">
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  <input
                    className={`form-control ${validationErrors.admin_first_name ? 'is-invalid' : ''}`}
                    type="text"
                    id="adminFirstNameInput"
                    value={step3Data.admin_first_name || ''}
                    onChange={(e) => handleStep3Change('admin_first_name', e.target.value)}
                    placeholder="First Name"
                  />
                  <label htmlFor="adminFirstNameInput">First Name *</label>
                  {validationErrors.admin_first_name && (
                    <div className="invalid-feedback">{validationErrors.admin_first_name}</div>
                  )}
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  <input
                    className={`form-control ${validationErrors.admin_last_name ? 'is-invalid' : ''}`}
                    type="text"
                    id="adminLastNameInput"
                    value={step3Data.admin_last_name || ''}
                    onChange={(e) => handleStep3Change('admin_last_name', e.target.value)}
                    placeholder="Last Name"
                  />
                  <label htmlFor="adminLastNameInput">Last Name *</label>
                  {validationErrors.admin_last_name && (
                    <div className="invalid-feedback">{validationErrors.admin_last_name}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="form-floating mb-3">
              <input
                className="form-control"
                type="text"
                id="adminTitleInput"
                value={step3Data.admin_title || 'User Permission Administrator'}
                readOnly
                placeholder="Title"
              />
              <label htmlFor="adminTitleInput">Title</label>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  <input
                    className={`form-control ${validationErrors.admin_phone_number ? 'is-invalid' : ''}`}
                    type="tel"
                    id="adminPhoneInput"
                    value={step3Data.admin_phone_number || ''}
                    onChange={(e) => handleStep3Change('admin_phone_number', e.target.value)}
                    placeholder="Phone Number"
                  />
                  <label htmlFor="adminPhoneInput">Phone Number *</label>
                  {validationErrors.admin_phone_number && (
                    <div className="invalid-feedback">{validationErrors.admin_phone_number}</div>
                  )}
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  <input
                    className={`form-control ${validationErrors.admin_email_address ? 'is-invalid' : ''}`}
                    type="email"
                    id="adminEmailInput"
                    value={step3Data.admin_email_address || ''}
                    onChange={(e) => handleStep3Change('admin_email_address', e.target.value)}
                    placeholder={getEmailPlaceholder()}
                  />
                  <label htmlFor="adminEmailInput">
                    Email Address * {step1Data.domain && <small className="text-muted">(@{step1Data.domain})</small>}
                  </label>
                  {validationErrors.admin_email_address && (
                    <div className="invalid-feedback">{validationErrors.admin_email_address}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex justify-content-between mt-4">
        <button
          className="btn btn-secondary"
          onClick={previousStep}
        >
          Previous
        </button>
        <button
          className="btn btn-success"
          onClick={handleNext}
          disabled={loadingStates.step3}
        >
          {loadingStates.step3 ? 'Creating & Activating BMO...' : 'Create & Activate BMO'}
        </button>
      </div>
    </div>
  );
};

const CompletionSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
      </div>
      <h2 className="text-success mb-3">BMO Created & Activated Successfully!</h2>
      <p className="mb-4">
        The Bursary Management Organisation has been created and activated successfully with both Primary and Secondary Representatives. 
        Activation emails have been sent to both representatives with instructions to set up their accounts.
      </p>
      <div className="alert alert-info mb-4">
        <strong>Next Steps:</strong>
        <ul className="mb-0 mt-2 text-start">
          <li>Primary and Secondary Representatives will receive activation emails</li>
          <li>Representatives must activate their accounts within 48 hours</li>
          <li>Once activated, representatives can log in and manage the BMO</li>
          <li>The BMO is now active and ready for use</li>
        </ul>
      </div>
      <button
        className="btn btn-primary me-3"
        onClick={() => navigate('/backoffice-dashboard/ManageBMOs')}
      >
        View BMOs
      </button>
      <button
        className="btn btn-outline-primary"
        onClick={() => navigate('/backoffice-dashboard')}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

const BMOFormWizard = () => {
  const [currentStep, setCurrentStep] = useState(1);
  
  const stepLabels = [
    { label: "BMO Name", icon: "bi-building" },
    { label: "BMO Address", icon: "bi-geo-alt" },
    { label: "Representatives", icon: "bi-people" }
  ];
  
  // Form data for each step
  const [step1Data, setStep1Data] = useState({
    bmo_name: '',
    domain: ''
  });
  
  const [step2Data, setStep2Data] = useState({
    country: '',
    province: '',
    address_line_1: '',
    address_line_2: '',
    suburb: '',
    city: '',
    postcode: ''
  });
  
  const [step3Data, setStep3Data] = useState({
    // Primary Representative
    primary_first_name: '',
    primary_last_name: '',
    primary_title: '',
    primary_phone_number: '',
    primary_email_address: '',
    // Secondary Representative
    secondary_first_name: '',
    secondary_last_name: '',
    secondary_title: '',
    secondary_phone_number: '',
    secondary_email_address: '',
    // Self Administration Option
    selfadminister: false,
    // User Permission Administrator (only if selfadminister is true)
    admin_first_name: '',
    admin_last_name: '',
    admin_title: 'User Permission Administrator',
    admin_phone_number: '',
    admin_email_address: ''
  });

  // Loading states
  const [loadingStates, setLoadingStates] = useState({
    step1: false,
    step1DuplicateCheck: false,
    step2: false,
    step3: false
  });

  // Validation errors
  const [validationErrors, setValidationErrors] = useState({});

  // Handle form changes
  const handleStep1Change = (field, value) => {
    setStep1Data(prev => ({ ...prev, [field]: value }));
    // Clear validation error for this field
    if (validationErrors[field]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleStep2Change = (field, value) => {
    setStep2Data(prev => ({ ...prev, [field]: value }));
    if (validationErrors[field]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleStep3Change = (field, value) => {
    setStep3Data(prev => ({ ...prev, [field]: value }));
    if (validationErrors[field]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  // Validation functions
  const validateStep1 = () => {
    const errors = {};
    
    if (!step1Data.bmo_name?.trim()) {
      errors.bmo_name = 'BMO name is required';
    }
    
    if (!step1Data.domain?.trim()) {
      errors.domain = 'Domain is required';
    } else if (!/^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]?\.([a-zA-Z]{2,}\.?)+$/.test(step1Data.domain.trim())) {
      errors.domain = 'Please enter a valid domain (e.g., google.com)';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Check for duplicates
  const checkForDuplicates = async () => {
    setLoadingStates(prev => ({ ...prev, step1DuplicateCheck: true }));
    
    try {
      // Import axios
      const { default: axios } = await import('../api/Axios');
      
      const errors = {};
      
      // Check BMO name
      if (step1Data.bmo_name?.trim()) {
        try {
          const nameResponse = await axios.get(`accounts/bmo/check-name/?name=${encodeURIComponent(step1Data.bmo_name.trim())}`);
          if (nameResponse.data.exists) {
            errors.bmo_name = 'A BMO with this name already exists';
          }
        } catch (error) {
          console.error('Error checking BMO name:', error);
          // Don't block if check fails, but log it
        }
      }
      
      // Check domain
      if (step1Data.domain?.trim()) {
        try {
          const domainResponse = await axios.get(`accounts/bmo/check-domain/?domain=${encodeURIComponent(step1Data.domain.trim())}`);
          if (domainResponse.data.exists) {
            errors.domain = 'A BMO with this domain already exists';
          }
        } catch (error) {
          console.error('Error checking domain:', error);
          // Don't block if check fails, but log it
        }
      }
      
      if (Object.keys(errors).length > 0) {
        setValidationErrors(prev => ({ ...prev, ...errors }));
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('Error in duplicate check:', error);
      // Don't block submission if duplicate check fails
      return true;
    } finally {
      setLoadingStates(prev => ({ ...prev, step1DuplicateCheck: false }));
    }
  };

  const validateStep2 = () => {
    const errors = {};
    
    if (!step2Data.country?.trim()) {
      errors.country = 'Country is required';
    }
    
    if (!step2Data.province?.trim()) {
      errors.province = 'Province is required';
    }
    
    if (!step2Data.address_line_1?.trim()) {
      errors.address_line_1 = 'Address line 1 is required';
    }
    
    if (!step2Data.suburb?.trim()) {
      errors.suburb = 'Suburb is required';
    }
    
    if (!step2Data.city?.trim()) {
      errors.city = 'City is required';
    }
    
    if (!step2Data.postcode?.trim()) {
      errors.postcode = 'Postal code is required';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateStep3 = () => {
    const errors = {};
    const bmoDomain = step1Data.domain?.trim();
    
    // Primary Representative validation
    if (!step3Data.primary_first_name?.trim()) {
      errors.primary_first_name = 'Primary representative first name is required';
    }
    
    if (!step3Data.primary_last_name?.trim()) {
      errors.primary_last_name = 'Primary representative last name is required';
    }
    
    if (!step3Data.primary_phone_number?.trim()) {
      errors.primary_phone_number = 'Primary representative phone number is required';
    }
    
    if (!step3Data.primary_email_address?.trim()) {
      errors.primary_email_address = 'Primary representative email is required';
    } else if (!/\S+@\S+\.\S+/.test(step3Data.primary_email_address)) {
      errors.primary_email_address = 'Primary representative email is invalid';
    } else if (bmoDomain && !step3Data.primary_email_address.toLowerCase().endsWith(`@${bmoDomain.toLowerCase()}`)) {
      errors.primary_email_address = `Primary representative email must use the domain @${bmoDomain}`;
    }
    
    // Secondary Representative validation
    if (!step3Data.secondary_first_name?.trim()) {
      errors.secondary_first_name = 'Secondary representative first name is required';
    }
    
    if (!step3Data.secondary_last_name?.trim()) {
      errors.secondary_last_name = 'Secondary representative last name is required';
    }
    
    if (!step3Data.secondary_phone_number?.trim()) {
      errors.secondary_phone_number = 'Secondary representative phone number is required';
    }
    
    if (!step3Data.secondary_email_address?.trim()) {
      errors.secondary_email_address = 'Secondary representative email is required';
    } else if (!/\S+@\S+\.\S+/.test(step3Data.secondary_email_address)) {
      errors.secondary_email_address = 'Secondary representative email is invalid';
    } else if (bmoDomain && !step3Data.secondary_email_address.toLowerCase().endsWith(`@${bmoDomain.toLowerCase()}`)) {
      errors.secondary_email_address = `Secondary representative email must use the domain @${bmoDomain}`;
    }
    
    // Check if primary and secondary email addresses are the same
    if (step3Data.primary_email_address?.trim() && 
        step3Data.secondary_email_address?.trim() && 
        step3Data.primary_email_address.toLowerCase() === step3Data.secondary_email_address.toLowerCase()) {
      errors.primary_email_address = 'Primary and secondary representative email addresses must be different';
      errors.secondary_email_address = 'Primary and secondary representative email addresses must be different';
    }
    
    // User Permission Administrator validation (only if selfadminister is enabled)
    if (step3Data.selfadminister) {
      if (!step3Data.admin_first_name?.trim()) {
        errors.admin_first_name = 'User Permission Administrator first name is required';
      }
      
      if (!step3Data.admin_last_name?.trim()) {
        errors.admin_last_name = 'User Permission Administrator last name is required';
      }
      
      if (!step3Data.admin_phone_number?.trim()) {
        errors.admin_phone_number = 'User Permission Administrator phone number is required';
      }
      
      if (!step3Data.admin_email_address?.trim()) {
        errors.admin_email_address = 'User Permission Administrator email is required';
      } else if (!/\S+@\S+\.\S+/.test(step3Data.admin_email_address)) {
        errors.admin_email_address = 'User Permission Administrator email is invalid';
      } else if (bmoDomain && !step3Data.admin_email_address.toLowerCase().endsWith(`@${bmoDomain.toLowerCase()}`)) {
        errors.admin_email_address = `User Permission Administrator email must use the domain @${bmoDomain}`;
      }
    }
    
    // Cross-validation: Ensure all emails are unique (only check if selfadminister is enabled and admin email exists)
    if (step3Data.selfadminister && step3Data.admin_email_address?.trim()) {
      // Check admin email against primary
      if (step3Data.primary_email_address?.trim() && 
          step3Data.admin_email_address.toLowerCase() === step3Data.primary_email_address.toLowerCase()) {
        errors.admin_email_address = 'User Permission Administrator email must be different from primary representative email';
        errors.primary_email_address = 'Primary representative email must be different from User Permission Administrator email';
      }
      
      // Check admin email against secondary
      if (step3Data.secondary_email_address?.trim() && 
          step3Data.admin_email_address.toLowerCase() === step3Data.secondary_email_address.toLowerCase()) {
        errors.admin_email_address = 'User Permission Administrator email must be different from secondary representative email';
        errors.secondary_email_address = 'Secondary representative email must be different from User Permission Administrator email';
      }
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Submit functions (placeholder - will be implemented later)
  const submitStep1Data = async () => {
    setLoadingStates(prev => ({ ...prev, step1: true }));
    
    try {
      // Placeholder for API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log('Step 1 data:', step1Data);
      return true;
    } catch (error) {
      console.error('Error submitting step 1:', error);
      return false;
    } finally {
      setLoadingStates(prev => ({ ...prev, step1: false }));
    }
  };

  const submitStep2Data = async () => {
    setLoadingStates(prev => ({ ...prev, step2: true }));
    
    try {
      // Placeholder for API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log('Step 2 data:', step2Data);
      return true;
    } catch (error) {
      console.error('Error submitting step 2:', error);
      return false;
    } finally {
      setLoadingStates(prev => ({ ...prev, step2: false }));
    }
  };

  const submitStep3Data = async () => {
    setLoadingStates(prev => ({ ...prev, step3: true }));
    
    try {
      // Import axios
      const { default: axios } = await import('../api/Axios');
      
      // Step 0: Pre-validate that representative emails don't already exist
      console.log('Pre-validating representative emails...');
      
      // Check primary representative email
      const primaryEmailCheck = await axios.post('accounts/check-email/', {
        email_address: step3Data.primary_email_address
      });
      
      if (primaryEmailCheck.data.exists) {
        throw new Error(`Primary representative email already exists: ${step3Data.primary_email_address}`);
      }
      
      // Check secondary representative email
      const secondaryEmailCheck = await axios.post('accounts/check-email/', {
        email_address: step3Data.secondary_email_address
      });
      
      if (secondaryEmailCheck.data.exists) {
        throw new Error(`Secondary representative email already exists: ${step3Data.secondary_email_address}`);
      }
      
      // Check admin email if self-administered
      if (step3Data.selfadminister && step3Data.admin_email_address) {
        const adminEmailCheck = await axios.post('accounts/check-email/', {
          email_address: step3Data.admin_email_address
        });
        
        if (adminEmailCheck.data.exists) {
          throw new Error(`Admin email already exists: ${step3Data.admin_email_address}`);
        }
      }
      
      console.log('Email pre-validation passed. Proceeding with BMO creation...');
      
      // Step 1: Create BMO with combined step1 and step2 data
      const bmoData = {
        name: step1Data.bmo_name.trim(),
        domain: step1Data.domain.trim(),
        addresslines: `${step2Data.address_line_1.trim()}${step2Data.address_line_2 ? ', ' + step2Data.address_line_2.trim() : ''}`,
        suburb: step2Data.suburb.trim(),
        city: step2Data.city.trim(),
        country: step2Data.country,
        province: step2Data.province,
        postcode: step2Data.postcode.trim(),
        selfadminister: step3Data.selfadminister || false
      };
      
      console.log('Creating BMO with data:', bmoData);
      console.log('Step1 data:', step1Data);
      console.log('Step2 data:', step2Data);
      
      let bmoResponse;
      try {
        bmoResponse = await axios.post('accounts/bmo/create/', bmoData);
        console.log('BMO created successfully:', bmoResponse.data);
      } catch (bmoError) {
        console.error('BMO creation failed:', bmoError);
        console.error('BMO error response:', bmoError.response?.data);
        console.error('BMO error status:', bmoError.response?.status);
        
        // Check if it's a specific validation error
        if (bmoError.response?.status === 400) {
          const errorData = bmoError.response.data;
          const errors = {};
          
          if (errorData.name) {
            errors.bmo_name = Array.isArray(errorData.name) ? errorData.name[0] : errorData.name;
          }
          if (errorData.domain) {
            errors.domain = Array.isArray(errorData.domain) ? errorData.domain[0] : errorData.domain;
          }
          if (errorData.addresslines) {
            errors.address_line_1 = Array.isArray(errorData.addresslines) ? errorData.addresslines[0] : errorData.addresslines;
          }
          if (errorData.suburb) {
            errors.suburb = Array.isArray(errorData.suburb) ? errorData.suburb[0] : errorData.suburb;
          }
          if (errorData.city) {
            errors.city = Array.isArray(errorData.city) ? errorData.city[0] : errorData.city;
          }
          if (errorData.country) {
            errors.country = Array.isArray(errorData.country) ? errorData.country[0] : errorData.country;
          }
          if (errorData.province) {
            errors.province = Array.isArray(errorData.province) ? errorData.province[0] : errorData.province;
          }
          if (errorData.postcode) {
            errors.postcode = Array.isArray(errorData.postcode) ? errorData.postcode[0] : errorData.postcode;
          }
          
          if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return false;
          }
        }
        
        // For 500 errors or other server errors
        setValidationErrors({
          general: `Server error occurred while creating BMO. Please check the backend logs. Error: ${bmoError.message}`
        });
        
        throw bmoError;
      }
        
      if (bmoResponse.status === 201) {
        const bmoId = bmoResponse.data.id;
        console.log('BMO created successfully with ID:', bmoId);
        console.log('BMO response data:', bmoResponse.data);
        
        // Verify domain was saved
        if (bmoResponse.data.domain) {
          console.log('Domain saved successfully:', bmoResponse.data.domain);
        } else {
          console.warn('Warning: Domain was not saved or returned from API');
        }
        
        // Step 2: Create Primary Representative
          const primaryRepData = {
            first_name: step3Data.primary_first_name,
            last_name: step3Data.primary_last_name,
            title: step3Data.primary_title,
            phone_number: step3Data.primary_phone_number,
            email_address: step3Data.primary_email_address,
            bmo_id: bmoId
          };
          
          console.log('Creating Primary Representative with data:', primaryRepData);
          const primaryRepResponse = await axios.post('accounts/create-primary-representative/', primaryRepData);
          console.log('Primary Rep Response:', primaryRepResponse.data);
        
          if (primaryRepResponse.status === 201) {
            console.log('Primary Representative created successfully');
            
            // Step 3: Create Secondary Representative
            const secondaryRepData = {
              first_name: step3Data.secondary_first_name,
              last_name: step3Data.secondary_last_name,
              title: step3Data.secondary_title,
              phone_number: step3Data.secondary_phone_number,
              email_address: step3Data.secondary_email_address,
              bmo_id: bmoId
            };
            
            console.log('Creating Secondary Representative with data:', secondaryRepData);
            const secondaryRepResponse = await axios.post('accounts/create-secondary-representative/', secondaryRepData);
            
            if (secondaryRepResponse.status === 201) {
              console.log('Secondary Representative created successfully');
              
              // Step 3.5: Create BMO User Admin if self-administered
              if (step3Data.selfadminister) {
                const adminData = {
                  first_name: step3Data.admin_first_name,
                  last_name: step3Data.admin_last_name,
                  phone_number: step3Data.admin_phone_number,
                  email_address: step3Data.admin_email_address,
                  bmo_id: bmoId
                };
                
                console.log('Creating BMO User Admin with data:', adminData);
                const adminResponse = await axios.post('accounts/create-bmo-user-admin/', adminData);
                
                if (adminResponse.status === 201) {
                  console.log('BMO User Admin created successfully');
                } else {
                  throw new Error('Failed to create BMO User Admin');
                }
              }
              
              // Step 4: Activate the BMO
              console.log('Activating BMO with ID:', bmoId);
              const activateResponse = await axios.patch(`accounts/bmo/${bmoId}/activate/`, {
                active: true
              });
              
              if (activateResponse.status === 200) {
                console.log('BMO activated successfully');
                console.log('All BMO data created and activated successfully');
                
                // Navigate to success step
                setCurrentStep(4);
                return true;
              } else {
                throw new Error('Failed to activate BMO');
              }
            } else {
              throw new Error('Failed to create Secondary Representative');
            }
          } else {
            throw new Error('Failed to create Primary Representative');
          }
      } else {
        throw new Error('Failed to create BMO');
      }
    } catch (error) {
      console.error('Error in BMO creation process:', error);
      console.error('Error response data:', error.response?.data);
      console.error('Error response status:', error.response?.status);
      
      // Handle pre-validation email exists errors
      if (error.message && error.message.includes('email already exists')) {
        const errors = {};
        if (error.message.includes('Primary representative email')) {
          errors.primary_email_address = 'A user with this email address already exists';
        }
        if (error.message.includes('Secondary representative email')) {
          errors.secondary_email_address = 'A user with this email address already exists';
        }
        if (error.message.includes('Admin email')) {
          errors.admin_email_address = 'A user with this email address already exists';
        }
        setValidationErrors(errors);
        return false;
      }
      
      // Set validation errors based on the error response
      if (error.response?.data) {
        const errorData = error.response.data;
        const errors = {};
        
        // Handle BMO creation errors
        if (errorData.name) errors.bmo_name = errorData.name[0];
        if (errorData.domain) {
          errors.domain = errorData.domain[0];
          console.error('Domain validation error:', errorData.domain[0]);
        }
        if (errorData.addresslines) errors.address_line_1 = errorData.addresslines[0];
        if (errorData.suburb) errors.suburb = errorData.suburb[0];
        if (errorData.city) errors.city = errorData.city[0];
        
        // Handle representative creation errors
        if (errorData.first_name) errors.primary_first_name = errorData.first_name[0];
        if (errorData.last_name) errors.primary_last_name = errorData.last_name[0];
        if (errorData.phone_number) errors.primary_phone_number = errorData.phone_number[0];
        if (errorData.email_address) {
          if (errorData.email_address[0].includes('already exists')) {
            errors.primary_email_address = errorData.email_address[0];
          } else {
            errors.primary_email_address = errorData.email_address[0];
          }
        }
        
        setValidationErrors(errors);
      } else {
        // Generic error handling
        setValidationErrors({
          general: 'An error occurred while creating the BMO and representatives. Please try again.'
        });
      }
      
      return false;
    } finally {
      setLoadingStates(prev => ({ ...prev, step3: false }));
    }
  };

  // Navigation functions
  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const previousStep = () => {
    setCurrentStep(prev => prev - 1);
  };

  const goToStep = (step) => {
    if (step <= currentStep) {
      setCurrentStep(step);
    }
  };

  return (
    <>
      <div className="wizardbox">
        <div className="step-indicator mb-4 d-flex justify-content-between align-items-end" style={{ gap: 0 }}>
          {stepLabels.map((step, index) => {
            const stepNum = index + 1;
            const isActive = currentStep === stepNum;
            const isCompleted = currentStep > stepNum;
            const isClickable = stepNum <= currentStep;
            
            return (
              <div
                key={stepNum}
                className={`step text-center ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""}`}
                style={{
                  flex: 1,
                  position: "relative",
                  zIndex: 1,
                  minWidth: 100,
                  cursor: isClickable ? 'pointer' : 'default'
                }}
                onClick={() => {
                  if (isClickable) {
                    goToStep(stepNum);
                  }
                }}
              >
                <div
                  className={`circle d-flex align-items-center justify-content-center mb-2 ${isActive ? "circle-active" : ""} ${isCompleted ? "circle-completed" : ""}`}
                  style={{
                    width: 60,
                    height: 60,
                    margin: "0 auto",
                    borderRadius: "50%",
                    background: isActive
                      ? "linear-gradient(135deg, #296f93 60%, #5bc0de 100%)"
                      : isCompleted
                      ? "linear-gradient(135deg, #28a745 60%, #20c997 100%)"
                      : "#e9ecef",
                    color: isActive || isCompleted ? "#fff" : "#adb5bd",
                    fontSize: 32,
                    boxShadow: isActive
                      ? "0 0 0 4px #296f9333"
                      : isCompleted
                      ? "0 0 0 2px #28a74533"
                      : "none",
                    border: isActive ? "2px solid #296f93" : isCompleted ? "2px solid #28a745" : "2px solid #dee2e6",
                    transition: "all 0.2s"
                  }}
                >
                  <i className={`bi ${step.icon}`} />
                </div>
                <div
                  className="label small fw-bold"
                  style={{
                    color: isActive
                      ? "#296f93"
                      : isCompleted
                      ? "#28a745"
                      : "#6c757d",
                    fontSize: isActive ? 18 : 15,
                    marginTop: 4,
                    letterSpacing: 0.5,
                    transition: "color 0.2s, font-size 0.2s"
                  }}
                >
                  {step.label}
                </div>
                {/* Progress bar connector */}
                {index < stepLabels.length - 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 30,
                      right: -50,
                      width: 100,
                      height: 6,
                      background: isCompleted
                        ? "linear-gradient(90deg, #28a745 60%, #20c997 100%)"
                        : "#dee2e6",
                      zIndex: 0,
                      borderRadius: 3,
                      transition: "background 0.2s"
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>

        {currentStep === 1 && (
          <Step1BMOName
            step1Data={step1Data}
            handleStep1Change={handleStep1Change}
            validateStep1={validateStep1}
            checkForDuplicates={checkForDuplicates}
            submitStep1Data={submitStep1Data}
            loadingStates={loadingStates}
            nextStep={nextStep}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
        )}

        {currentStep === 2 && (
          <Step2BMOAddress
            step2Data={step2Data}
            handleStep2Change={handleStep2Change}
            validateStep2={validateStep2}
            submitStep2Data={submitStep2Data}
            loadingStates={loadingStates}
            nextStep={nextStep}
            previousStep={previousStep}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
        )}

        {currentStep === 3 && (
          <Step3BMORepresentatives
            step1Data={step1Data}
            step3Data={step3Data}
            handleStep3Change={handleStep3Change}
            validateStep3={validateStep3}
            submitStep3Data={submitStep3Data}
            loadingStates={loadingStates}
            previousStep={previousStep}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
        )}

        {currentStep === 4 && <CompletionSuccess />}
      </div>

      <style>
        {`
          .wizardbox {
            width: 100%;
            min-height: 100vh;
            margin: 0;
            padding: 2rem;
            background: white;
            position: relative;
            overflow: hidden;
          }

          h3 {
            font-size: 22px;
            color: #495057;
            font-weight: 600;
            margin: 2rem 0 1.5rem 0;
            padding: 0.75rem 0;
            border-bottom: 2px solid #e9ecef;
            position: relative;
          }
          
          h3::before {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 60px;
            height: 2px;
            background: linear-gradient(45deg, #296f93, #5bc0de);
            border-radius: 1px;
          }
          
          h3:first-child {
            margin-top: 0;
          }

          .step-indicator .circle {
            transition: box-shadow 0.2s, border 0.2s, background 0.2s, color 0.2s;
          }
          .step-indicator .circle-active {
            animation: pulse 0.7s;
          }
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 #296f9355; }
            70% { box-shadow: 0 0 0 10px #296f9322; }
            100% { box-shadow: 0 0 0 0 #296f9355; }
          }

          /* MDB5 validation styles */
          .form-control.is-invalid,
          .form-select.is-invalid {
            border-color: #dc3545;
            box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
            background-color: rgba(220, 53, 69, 0.05);
          }
          
          .form-control.is-invalid:focus,
          .form-select.is-invalid:focus {
            border-color: #dc3545;
            box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
            background-color: rgba(220, 53, 69, 0.05);
          }
          
          .invalid-feedback {
            display: block;
            width: 100%;
            margin-top: 0.5rem;
            font-size: 0.875rem;
            color: #fff;
            text-align: left;
            position: relative;
            z-index: 1;
            padding: 0.5rem 0.75rem;
            background: #dc3545;
            border-radius: 0.375rem;
            border: 1px solid #dc3545;
          }
          
          /* Add arrow pointer to validation message */
          .invalid-feedback::before {
            content: '';
            position: absolute;
            top: -5px;
            left: 1rem;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid #dc3545;
          }
        `}
      </style>
    </>
  );
};

export default BMOFormWizard;
